export const rootFont = {
    fontFamily:"'Gotham Black', sans-serif"
}